var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('textarea', {
    class: _vm.$props.customClass,
    attrs: {
      "id": _vm.id,
      "placeholder": _vm.$props.placeholder,
      "disabled": _vm.$props.disabled,
      "maxlength": _vm.$props.maxlength,
      "cols": _vm.$props.cols,
      "rows": _vm.$props.rows,
      "readonly": _vm.$props.readOnly
    },
    on: {
      "input": _vm.handleInput
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }